<template>
  <section class="page-container">
    <h1>Import Tracking Number</h1>
    <div
      class="btn-top-container">
      <v-button @click="handleBack">
        Previous
      </v-button>
      <v-button
        type="success"
        icon="plus"
        @click="handleImport">Import New File</v-button>
    </div>

    <div class="transparent">
      <el-table
        :data="form"
        style="width: 100%"
        :header-row-class-name="'tableHeader'">
        <el-table-column
          prop="id"
          width="80px"
          align="center"
          label="ID"></el-table-column>
        <el-table-column
          prop="upload_time"
          width="200px"
          label="Upload Time"></el-table-column>
        <el-table-column
          label="File Name">
          <template #default={row}>
            <a
              class="file"
              :href="row.file_url"
              @click="download(row.file_url,row.file_client_name)">{{row.file_client_name}}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="status_language"
          width="100px"
          label="Status"></el-table-column>
        <el-table-column
          prop="total"
          align="center"
          width="100px"
          label="Total">
          <template #default={row}>
            {{row.status? row.total : '-'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="success_total"
          align="center"
          width="100px"
          label="Successful">
          <template #default={row}>
            <span :class="{'green': row.status}">{{row.status? row.success_total : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="100px"
          label="Failed">
          <template #default={row}>
            <span :class="{'red': row.status}">{{row.status? row.failed_total : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Skip"
          align="center"
          width="100px">
          <template #default={row}>
            <span>{{row.status? row.skip_total : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
          label="Result">
          <template #default={row}>
            <div
              v-show="row.status"
              class="res"
              @click="resClick(row)">
              Result >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />

    <!-- dialog -->
    <import-result
      ref="result-dialog"
      :rowInfo='rowInfo'></import-result>
    
    <import-file
      ref="file-dialog"
      @uploadSuccess="handlerUploadSuccess"></import-file>
  </section>
</template>

<script>
import ImportResult from './dialog/import-result'
import ImportFile from './dialog/import-file'
import {getExcelList} from '@/api/micropolicy'
import {downloadFileName} from '@/utils/download'
export default {
  name: 'ImportTracking',
  components:{
    ImportResult,
    ImportFile
  },
  data () {
    return {
      form: [],
      pageConfig: {
        currentPage: 1,
        total: 0
      },
      rowInfo:{}
    }
  },
  created(){
    this.network().getExcelList()
  },
  methods: {
    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getExcelList()
    },

    handleBack(){
      this.$router.go(-1)
    },

    handleImport(){
      this.$refs['file-dialog'].changeDialog()
    },
    
    resClick(row){
      this.rowInfo = row
      this.$refs['result-dialog'].changeDialog()
    },

    download(url,filename){
      event.preventDefault()
      downloadFileName(url,filename)
    },

    handlerUploadSuccess(){
      this.network().getExcelList()
    },

    network(){
      return {
        getExcelList: async() => {
          let params = {
            page: this.pageConfig.currentPage
          }
          const {data}  = await getExcelList(params)
          this.form = data.data
          this.pageConfig.currentPage = data.current_page
          this.pageConfig.total = data.total
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  position: relative;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  .file{
    color: #409EFF;
    text-decoration: none;
  }
  .res{
    color: #409EFF;
    cursor: pointer;
  }
  .green{
    color: #28A745;
  }
  .red{
    color: #CB2431;
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
     .cell{
       line-height: 18px;
       position: relative;
       height: inherit;
       padding: 0;
     }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
}
</style>
